export function ifNotWx(f) {

    if (!isWx())
        f()
}

export function ifWx(f) {

    if (isWx())
        f()
}


export function isWx() {
    return true
    // let ua = navigator.userAgent.toLowerCase();
    // return ua.indexOf('micromessenger') !== -1;
}